
import { Vue, Component, Prop } from "vue-property-decorator";

import { IMeetingInfo } from "@/contants/current.ts";
import QRCode from "qrcodejs2";

@Component({ components: {} })
export default class Pay extends Vue {
  private bannerSrc: any = "";
  private m: string = "";
  private time: number = 60;

  private orderid: string = "";

  @Prop({
    type: Object,
    default: {},
    required: true,
  })
  datas!: any;

  created() {
    this.countdown();
    this.$nextTick(() => {
      this.qrcode(this.datas.code_url);
    });
  }

  /**
   * 倒计时
   */
  countdown() {
    let _countdown = setInterval(() => {
      this.time--;
      if (this.time <= 0) {
        clearInterval(_countdown);
      }
    }, 1000);
  }
  /**
   * 生成二维码
   */
  qrcode(link: string) {
    new QRCode("qrcode", {
      // width: 256,
      // height: 256, // 高度
      text: link, // 二维码内容
      render: "table", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      correctLevel: QRCode.CorrectLevel.H,
    });
  }
}
